import { defineStore } from 'pinia';
import { ref } from 'vue';

import { ToastType, type Snackbar, type Toast } from '@/types/toastSnackbar.type';

export const useToastSnackbarStore = defineStore('toastSnack', () => {
  const snackbars = ref<Snackbar[]>([]);
  const toasts = ref<Toast[]>([]);

  function addToast(toast: Toast) {
    toasts.value.push(toast);
  }

  function addErrorToast(toast: Toast) {
    toast.toastType = ToastType.Error;
    addToast(toast);
  }

  function addSuccessToast(toast: Toast) {
    toast.toastType = ToastType.Success;
    addToast(toast);
  }

  function addSnackbar(newSnackbar: Snackbar) {
    if (!Object.prototype.hasOwnProperty.call(newSnackbar, 'isShown')) {
      newSnackbar.isShown = true;
    }

    snackbars.value.push(newSnackbar);
  }

  function clearToasts() {
    toasts.value = [];
  }

  function clearSnackbar(snackbarToRemove: Snackbar) {
    snackbars.value = snackbars.value.filter((item: Snackbar) => {
      return item.id !== snackbarToRemove.id;
    });
  }

  return {
    snackbars,
    toasts,
    addToast,
    addErrorToast,
    addSuccessToast,
    clearToasts,
    addSnackbar,
    clearSnackbar,
  };
});

export default useToastSnackbarStore;
